<template>
  <div class="t-calendar-lessons">
    <div class="t-calendar-lesson" v-for="(lesson, index) in lessons_in_week"
         :key="'lesson_' + index"
         :class="{'t-calendar-lesson_select': lesson.select, 't-calendar-lesson_disabled': !lesson.select && !lesson.place, 't-calendar-lesson_hover': !lesson.select && lesson.place}"
         :style="'grid-column-start: ' + lesson.grid_column + '; grid-row-start:' + lesson.grid_row_start  + '; grid-row-end:' + lesson.grid_row_end"
         @click.prevent="Select(lesson)">
      <span class="t-calendar-lesson__time" v-if="lesson.grid_row_end > (lesson.grid_row_start+1)">{{ lesson.time }}</span>
      <span class="t-calendar-lesson__title">{{ lesson.title }}</span>
    </div>
  </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import TimeMixin from '../TimeMixin';
    
    export default {
        mixins: [TimeMixin],
        computed: {
            ...mapGetters('profile', ['hasAuth']),
            ...mapGetters('calendar', ['day_week_header', 'filter', 'calendarText']),
            ...mapGetters('coursesList', ['course', 'streams']),
            lessons_in_week(){
                let les = [];

                let streams = [];

                if(this.course.type === 3){
                    streams.push(this.streams[this.filter.value.value]);
                } else{
                    streams = this.streams;
                }

                for(let s = 0; s < streams.length; s++){
                    let stream = streams[s];

                    for(let l = 0; l < stream.lessons.length; l++){
                        let lesson = stream.lessons[l];

                        let date = new Date(lesson.date_time);

                        let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                        let month = (parseInt(date.getMonth()) + 1)  < 10 ? '0' + (date.getMonth() + 1): (date.getMonth() + 1);
                        let date_string = date.getFullYear() + '.' + month + '.' + day;

                        if(this.week_arr.indexOf(date_string) >= 0){
                            let index = this.getIndex(date)  // берестя из миксина TimeMixin
                            
                            let hours = date.getHours();
                            let minutes = date.getMinutes();

                            let grid_row_start = (hours + 1) * 2;
                            if(minutes === 0)
                                grid_row_start--;

                            let grid_row_end = grid_row_start + lesson.duration / 30;
                            let title = '', time = '';
                            let place = false, select = false;

                            if(this.course.belonging){
                                title = stream.applications.confirmed + ' ' + this.declOfNum(stream.applications.confirmed, this.calendarText.applicationArr);
                                time = stream.applications.new + ' ' + this.declOfNum(stream.applications.new, this.calendarText.applicationNewArr);
                            } else{
                                let time_start = [];
                                time_start.push(hours < 10 ? '0' + hours : hours);
                                time_start.push(minutes < 10 ? '0' + minutes : minutes);

                                time += time_start.join(':');

                                minutes = (hours * 60) + minutes + lesson.duration;
                                hours = Math.floor(minutes / 60);
                                minutes = minutes - hours * 60;

                                if(hours < 10)
                                    hours = '0' + hours;
                                if(minutes < 10)
                                    minutes = '0' + minutes;
                                time += '-' + hours + ':' + minutes;

                                if(stream.select){
                                    title = this.calendarText.myApplication;
                                    select = true;
                                } else{
                                    if(this.course.type === 3){
                                        title = (l + 1) + this.calendarText.lesson;
                                        if(stream.place && stream.choose){
                                            place = true;
                                        }
                                    } else{
                                        if(stream.place && stream.choose){
                                            place = true;
                                            title = this.calendarText.placeYes;
                                        } else{
                                            if(!stream.place && stream.choose){
                                                title = this.calendarText.placeNo;
                                            } else{
                                                title = this.calendarText.placeYes;
                                            }
                                        }
                                    }
                                }
                            }

                            les.push({
                                grid_column: index + 1,
                                grid_row_start: grid_row_start,
                                grid_row_end: grid_row_end,
                                title: title,
                                time: time,
                                select: select,
                                place: place,
                                id: [stream.id]
                            });
                        }
                    }
                }

                return les
            }
        },
        methods: {
            ...mapActions('modal', ['modalDialogType_authOpen']),
            ...mapActions('coursesList', ['setStreamId']),
            ...mapActions('modal', ['modalDialogType_signUpOpen']),
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            Select(lesson){
                if(this.hasAuth){
                    if(!this.course.belonging && !lesson.select && lesson.place){
                        this.setStreamId(lesson.id);
                        this.modalDialogType_signUpOpen();
                    }
                } else{
                    this.modalDialogType_authOpen();
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/vue_components/Calendar/View/Time.vue